import { Injectable } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { TaskPropertyObject } from 'src/app/models/tasks/tasks-properties/task-properties.model';
import { TaskDetailsProductObject } from 'src/app/models/tasks/tasks-details/tasks-details-product/task-details-product.model';
import { TaskScaiObject } from 'src/app/models/tasks/tasks-details/tasks-details-scai/task-scai.model';
import { TaskScaiConverter } from './task-scai-properties.converter';
import { TaskDetailsProductConverter } from './task-product-properties.converter';
import { TaskPropertyConverter } from './task-property.converter';
import { TaskCommentObject } from 'src/app/models/tasks/tasks-details/tasks-details-comments/task-comment.model';
import { TaskCommentsConverter } from './task-comments.converter';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { TaskOperationObject } from 'src/app/models/tasks/task/task-operation.model';
import { CharacteristicsConverter } from '../../characteristics/characteristics.converter';
import { SingleCharacteristicObject } from 'src/app/models/characteristics/characteristic/single-characteristic-object.model';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TasksOperationObject } from 'src/app/models/tasks/task/tasks-operation.model';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  appData: any;

  constructor(
    private taskDetailsProductConverter: TaskDetailsProductConverter,
    private taskPropertyConverter: TaskPropertyConverter,
    private taskScaiConverter: TaskScaiConverter,
    private characteristicsConverter: CharacteristicsConverter,
    private taskCommentsConverter: TaskCommentsConverter, appService: AppService,
    private httpClient: HttpClient) {
    this.appData = appService.settings;
  }


  public getTask(taskId: string): Observable<TaskDetailsObject> {

    let taskDetailsObject: TaskDetailsObject;

    return this.httpClient.get(`${this.appData.webApi}/tasks/${taskId}`).pipe(
      map(
        (response: any) => {
          try {
            const taskData = response;

            if (taskData === '') {
              console.error(`Task ${taskId} not found.`);
              taskDetailsObject = TaskDetailsObject.create();
            } else {
              const properties: TaskPropertyObject = this.taskPropertyConverter.convert(taskData);
              const product: TaskDetailsProductObject = this.taskDetailsProductConverter.convert(taskData);
              const scai: TaskScaiObject = this.taskScaiConverter.convert(taskData);
              const taskCharacteristics: CharacteristicsObject = this.characteristicsConverter
                .convert(taskData.order.service.characteristics);
              const comments: Array<TaskCommentObject> = this.taskCommentsConverter.convert(taskData);
              taskDetailsObject = new TaskDetailsObject(product, taskCharacteristics, scai, comments, properties);
              return taskDetailsObject;
            }
          } catch (error) {
            console.error(error);
            return TaskDetailsObject.create();
          }
        }
      ));
  }

  public assingTask(id: string, userId: string): Observable<any> {
    return this.httpClient.put(`${this.appData.webApi}/tasks/${id}/claim`, {userId}).pipe(
      map(
        (response: any) => {
          return response;
        },
        (error) => {
          throw error;
        }
      ));
  }

  public leaveTask(id: string): Observable<any> {
    return this.httpClient.put(`${this.appData.webApi}/tasks/${id}/release`, {}).pipe(
      map(
        (response: any) => {
          return response;
        },
        (error) => {
          throw error;
        }
      ));

  }

  public skipTask(userId: string, taskId: string, operation: TaskOperationObject): Observable<any> {

    const characteristics: any = this.prepareRequest(operation).characteristicsSingleValue;

    const comments: string = operation.comments.message;

    const offerId: string = null;

    return this.httpClient.patch(`${this.appData.webApi}/tasks/${taskId}/skip`,
      { characteristics, comments, offerId, userId }).pipe(
        map(
          (response: any) => {
            return response;
          },
          (error) => {
            throw error;
          }
        ));
  }

  public relaunchTask(userId: string, taskId: string, operation: TaskOperationObject): Observable<any> {

    const characteristics: any = this.prepareRequest(operation).characteristicsSingleValue;


    const comments: string = operation.comments.message;

    const offerId: string = null;

    return this.httpClient.patch(`${this.appData.webApi}/tasks/${taskId}/relaunch`,
      { characteristics, comments, offerId, userId }).pipe(
        map(
          (response: any) => {
            return response;
          },
          (error) => {
            throw error;
          }
        ));

  }

  public relaunchTasks(userId: string, operation: TasksOperationObject): Observable<any> {

    const idTasks: any = this.prepareMassiveRequest(operation);

    const comments: string = operation.comments.message;

    const offerId: string = null;

    return this.httpClient.put(`${this.appData.webApi}/tasks/massive/relaunch`,
      { idTasks, comments, offerId, userId }).pipe(
        map(
          (response: any) => {
            return response;
          },
          (error) => {
            throw error;
          }
        ));

  }

  public bypassTasks(userId: string, operation: TasksOperationObject): Observable<any> {

    const idTasks: any = this.prepareMassiveRequest(operation);

    const comments: string = operation.comments.message;

    const offerId: string = null;

    return this.httpClient.put(`${this.appData.webApi}/tasks/massive/skip`,
      { idTasks, comments, offerId, userId }).pipe(
        map(
          (response: any) => {
            return response;
          },
          (error) => {
            throw error;
          }
        ));

  }

  public fullRelaunchTasks(userId: string, operation: TasksOperationObject): Observable<any> {

    const orders: any = this.prepareMassiveRequestFullRelaunch(operation);

    const comments: string = operation.comments.message;

    const offerId: string = null;

    return this.httpClient.put(`${this.appData.webApi}/tasks/massive/fullRelaunch`,
      { orders, comments, offerId, userId }).pipe(
        map(
          (response: any) => {
            return response;
          },
          (error) => {
            throw error;
          }
        ));

  }

  public prepareRequest(operation: TaskOperationObject): any {
    const characteristics: any = {};
    const characteristicsSingleValue: Array<any> = [];
    const characteristicsMultiValue: Array<any> = [];
    for (const char of operation.characteristics.inputCharacteristics) {
      const id = char.id;
      const name = char.name;
      const value = char.value;
      if (char instanceof SingleCharacteristicObject) {
        characteristicsSingleValue.push({ id, name, value });
      } else {
        characteristicsMultiValue.push({ id, name, value });
      }
    }
    for (const char of operation.characteristics.outputCharacteristics) {
      const id = char.id;
      const name = char.name;
      const value = char.value;
      if (char instanceof SingleCharacteristicObject) {
        characteristicsSingleValue.push({ id, name, value });
      } else {
        characteristicsMultiValue.push({ id, name, value });
      }
    }
    characteristics.characteristicsSingleValue = characteristicsSingleValue;
    characteristics.characteristicsMultiValue = characteristicsMultiValue;
    return characteristics;
  }

  public prepareMassiveRequest(operation: TasksOperationObject): string [] {
    return operation.tasks.map(task => task.idTask.toString());
  }

  public prepareMassiveRequestFullRelaunch(operation: TasksOperationObject): string [] {
    return operation.tasks.map(task => task.orderId.toString());
  }

}
